// What a screen the Live sample leaves out draws in its place (PRD 117 §
// "Neutralise"): billing, buying, connecting a bank, Franklin. Outside demo
// mode it renders its children and nothing else.

import React from 'react';
import { YStack } from 'tamagui';
import { GBText } from '@greenbackapp/ui';
import { DEMO_UNAVAILABLE_COPY, isDemo } from '../../config/demo';

export const DemoUnavailable: React.FC<{ message?: string; detail?: string }> = ({
  message = DEMO_UNAVAILABLE_COPY,
  detail = 'Everything else in the sample is yours to explore.',
}) => (
  <YStack padding={32} alignItems="center" gap={8} data-testid="demo-unavailable">
    <GBText variant="titleMedium" bold center>{message}</GBText>
    <GBText variant="bodyMedium" color="secondary" center>{detail}</GBText>
  </YStack>
);

/** Renders `children` everywhere except the Live sample, where it says why not. */
export const DemoGate: React.FC<{ children: React.ReactNode; message?: string; detail?: string }> = ({
  children,
  message,
  detail,
}) => (isDemo() ? <DemoUnavailable message={message} detail={detail} /> : <>{children}</>);

/** Renders `children` everywhere except the Live sample, where it renders nothing. */
export const HideInDemo: React.FC<{ children: React.ReactNode }> = ({ children }) =>
  isDemo() ? null : <>{children}</>;
